import { merge } from '../../helper';

import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import * as exElement from '../../utils/element';

import exData from './data';
import type { IOptionConfig } from './types';

// ----------------------------------------------------------------------------

function create(config: IOptionConfig = {}): HTMLOptionElement[] {
    // Default Config
    const defConfig: IOptionConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build: Record<string, any> = {
        list: [],
    };

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return build.list;
}

function settings(build: Record<string, any>, config: IOptionConfig = {}): void {
    // If using data
    if (!isEmptyObject(config.data) || !isEmptyArray(config.data)) {
        build.list = exData(config);
    }

    // If using placeholder or hidden
    if (config.placeholder != null || config.hidden != null) {
        // Create element (option placeholder or hidden)
        const elOption = exElement.create({
            tag: 'option',
            attr: {
                hidden: '',
                selected: '',
            },
        }) as HTMLOptionElement;

        // Set value
        elOption.value = '';

        // If using placeholder
        if (config.placeholder != null) {
            elOption.innerHTML = config.placeholder;
        }

        // List Unshift
        build.list.unshift(elOption);
    }
}

// ----------------------------------------------------------------------------

export { create };
export type { IOptionConfig } from './types';
